module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"History":"ისტორია"},"en":{"History":"History"}}')
  delete Component.options._Ctor
}
